import Vue from 'vue'
import VueGtag from 'vue-gtag'
import VueRouter from 'vue-router'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import 'animate.css'
import VueCarousel from 'vue-carousel'
import VueSlickCarousel from 'vue-slick-carousel'
import VueMeta from 'vue-meta'
import pasosForm from '@/components/pasos-form'

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.config.productionTip = false
Vue.use(VueSlickCarousel)
Vue.use(VueRouter)
Vue.use(VueCarousel)
Vue.use(VueGtag, {
  config: {
    id: 'G-XS99SBB69L',
    params: { send_page_view: false
    }
  }
}, router)

Vue.component('pasos-form', pasosForm)

new Vue({
  vuetify,
  store,
  router,
  VueCarousel,
  render: h => h(App)
}).$mount('#app')
